import { useQuery } from "@tanstack/react-query";
import { firmsService } from "@/services/firmsService";

export function useFirm(firmId: string | undefined) {
  return useQuery({
    queryKey: ["firms", firmId],
    queryFn: () => firmsService.fetchFirm(firmId!),
    staleTime: 60_000,
    enabled: Boolean(firmId),
  });
}


